<template>
  <div class="turnkey-projects-page">

    <!-- 搜索弹窗 -->
    <div class="search" v-show="searchVisible">
      <div class="sc_bj">
        <div class="sc_gb" @click="toggleSearch"><i class="iconfont icon-guanbi1"></i></div>
        <div class="sc_nr">
          <input type="text" v-model="searchKeyword" placeholder="Please enter keywords">
          <button @click="handleSearch"><i class="iconfont icon-tubiaozhizuomoban"></i></button>
          <div class="clear"></div>
        </div>
      </div>
    </div>

    <!-- 页面banner -->
    <div class="ny_ban" style="background-image:url(/images/n_ban2.jpg);">
      <div class="container">
        <h1 class="wow fadeInLeft" data-wow-delay=".5s">Turnkey Projects</h1>
      </div>
    </div>

    <!-- 项目主体区域 -->
    <div class="ny_al">
      <div class="container">
        <!-- 推荐项目轮播 -->
        <div class="al_tj wow fadeInUp" data-wow-delay=".5s">
          <div class="swiper-container swiper-al">
            <div class="swiper-wrapper">
              <div class="swiper-slide" v-for="(item, index) in topList" :key="index + refreshKey">
                <div class="row jt_ct an_tm">
                  <div class="tj_tp"><img :src="`https://cdn.bosscaigou.com/${item.himg}`"></div>
                  <div class="tj_wz">
                    <h3>{{ item.title }}</h3>
                    <p v-html="removeHtmlTags(item.detail)"></p>
                    <div class="b_q"><i class="iconfont icon-shijian"></i>{{ initTime(item.ctime) }}</div>
                    <a href="" @click.prevent="goToProjectDetail(item)">Read More<i>></i></a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="swiper-pagination"></div>
          <div class="swiper-button-prev" @click="swiper.slidePrev()"><i class="iconfont icon-zuojiantou"></i></div>
          <div class="swiper-button-next" @click="swiper.slideNext()"><i class="iconfont icon-zuojiantou"></i></div>
        </div>

        <!-- 项目列表 -->
        <div class="al_fl wow fadeInUp" data-wow-delay=".5s">
          <!-- 分类筛选 -->
          <div class="al_lm">
            <div class="al_lm-dropdown" @click.stop="toggleDropdown">
              <div class="al_lm-select">
                <span>{{ currentLabel }}</span>
                <i class="iconfonts" :class="{ 'is-open': dropdownOpen }">&#xEA4D;</i>
              </div>
              <div class="al_lm-options" v-show="dropdownOpen">
                <div v-for="(item, index) in categoryList" :key="index"
                  :class="{ on: nowType == item.id }" @click="selectCategory(item)">
                  {{ item.value }}
                </div>
              </div>
            </div>
          </div>

          <!-- 项目列表 -->
          <div class="al_lb">
            <ul class="row">
              <li v-for="(item, index) in projectList" :key="index">
                <div class="t_p"><a href="" @click.prevent="goToProjectDetail(item)"><img
                      :src="`https://cdn.bosscaigou.com/${item.himg}`" :alt="item.title"></a>
                </div>
                <div class="w_z">
                  <h3>{{ item.title }}</h3>
                  <div class="b_q">
                    <span :title="item?.articlesType?.value || 'ALL'">{{ item?.articlesType?.value || 'ALL' }}</span>
                    <a href="" @click.prevent="goToProjectDetail(item)">Read More<i>></i></a>
                  </div>
                </div>
              </li>
            </ul>
          </div>

          <el-pagination class="com-aonaer-wm-pagination" style="margin-top: 60px;" background
            @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="nowPge"
            :page-size="nowPsz" layout="prev, pager, next" :total="maxSize">
          </el-pagination>

          <!-- 分页 -->
          <!-- <div class="yema">
            <ul>
              <li><a href="javascript:;" @click="changePage(currentPage - 1)" :class="{ disabled: currentPage === 1 }">
                  <i class="iconfont icon-youjiantou"></i>
                </a></li>
              <li><a href="javascript:;" @click="changePage(1)" :class="{ on: currentPage === 1 }">1</a></li>
              <li><a href="javascript:;" @click="changePage(2)" :class="{ on: currentPage === 2 }">2</a></li>
              <li><a href="javascript:;" @click="changePage(3)" :class="{ on: currentPage === 3 }">3</a></li>
              <li>···</li>
              <li><a href="javascript:;" @click="changePage(totalPages)" :class="{ on: currentPage === totalPages }">{{
                totalPages }}</a></li>
              <li><a href="javascript:;" @click="changePage(currentPage + 1)"
                  :class="{ disabled: currentPage === totalPages }">
                  <i class="iconfont icon-zuojiantou"></i>
                </a></li>
            </ul>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// 引入Swiper（需先安装：npm install swiper@6.x）
import Swiper from 'swiper'
// import 'swiper/swiper-bundle.css'
import { listArticles2 } from '@/api';
// 引入Swiper5.x（适配Vue2）
import { initTime, jumpTo } from '@/utils/myutils';
export default {
  name: 'TurnkeyProjects',
  data() {
    return {
      refreshKey: 0,
      // 搜索相关
      searchVisible: false,
      searchKeyword: '',
      // 语言下拉框
      languageDropdownVisible: false,
      // 移动端导航
      mobileNavVisible: false,
      // Swiper实例
      swiper: null,
      // 推荐项目轮播数据
      recommendProjects: [
        {
          id: 1,
          image: 'al1.jpg',
          title: 'Qatar Slaughtering and Processing Supply Center',
          description: 'Here are some brief text introductions introducing the highlights of the project, Here are some brief text introductions introducing the highlights of the project, Here are some brief text introductions introducing the highlights of the project, ......',
          date: '2025-05-23'
        },
        {
          id: 2,
          image: 'al1.jpg',
          title: 'Qatar Slaughtering and Processing Supply Center',
          description: 'Here are some brief text introductions introducing the highlights of the project, Here are some brief text introductions introducing the highlights of the project, Here are some brief text introductions introducing the highlights of the project, ......',
          date: '2025-05-23'
        },
        {
          id: 3,
          image: 'al1.jpg',
          title: 'Qatar Slaughtering and Processing Supply Center',
          description: 'Here are some brief text introductions introducing the highlights of the project, Here are some brief text introductions introducing the highlights of the project, Here are some brief text introductions introducing the highlights of the project, ......',
          date: '2025-05-23'
        }
      ],
      // 项目分类
      projectCategories: ['Slaughter line', 'Slaughter line', 'Slaughter line', 'Slaughter line', 'Slaughter line'],
      // 选中的分类
      activeCategory: 'ALL',
      // 所有项目数据
      allProjects: [
        { id: 1, image: 'al1.jpg', title: 'Qatar 2022 World Cup Cattle, Sheep, and Camel Slaughter and Processing Project', category: 'Slaughter line' },
        { id: 2, image: 'al2.jpg', title: 'Snowflake and Sheep Slaughtering Line Project', category: 'Slaughter line' },
        { id: 3, image: 'al3.jpg', title: 'Zhengyang Muge Turkey Cattle Slaughtering Project', category: 'Slaughter line' },
        { id: 4, image: 'al1.jpg', title: 'Qatar 2022 World Cup Cattle, Sheep, and Camel Slaughter and Processing Project', category: 'Slaughter line' },
        { id: 5, image: 'al2.jpg', title: 'Snowflake and Sheep Slaughtering Line Project', category: 'Slaughter line' },
        { id: 6, image: 'al3.jpg', title: 'Zhengyang Muge Turkey Cattle Slaughter and Processing Project', category: 'Slaughter line' }
      ],
      // 分页
      currentPage: 1,
      totalPages: 6,
      // 每页显示数量
      pageSize: 6,
      // 项目列表
      projectList: [],
      // 项目分类
      typeOptions: [],
      // 项目推荐
      topList: [],
      // 最大页数
      maxSize: 0,
      // 项目类型
      nowType: -1,
      // 当前页
      nowPge: 1,
      // 每页显示数量
      nowPsz: 12,
      // 下拉展开状态
      dropdownOpen: false
    }
  },
  computed: {
    // 下拉选项列表（ALL + 后端分类）
    categoryList() {
      return [{
        id: -1,
        value: 'ALL',
        pid: 0
      }, ...this.typeOptions];
    },
    // 当前选中项的显示文本
    currentLabel() {
      const found = this.categoryList.find(item => item.id === this.nowType);
      return found ? found.value : 'ALL';
    },
    // 根据分类筛选项目
    filteredProjects() {
      if (this.activeCategory === 'ALL') {
        return this.allProjects
      }
      return this.allProjects.filter(project => project.category === this.activeCategory)
    }
  },
  mounted() {
    // 初始化WOW动画（如需保留）
    // if (window.WOW) new window.WOW().init()

    window.scrollTo(0, 0)



    this.listArticlesFuc();

    // 返回顶部功能
    window.addEventListener('scroll', this.handleScroll)
    // 点击外部关闭下拉
    document.addEventListener('click', this.onDocumentClick)
  },
  beforeDestroy() {
    // 销毁Swiper实例
    if (this.swiper) {
      this.swiper.destroy(true, true)
    }
    window.removeEventListener('scroll', this.handleScroll)
    document.removeEventListener('click', this.onDocumentClick)
  },
  methods: {
    removeHtmlTags(str) {
      // 匹配所有 <xxx> 标签，全局替换为空
      return str.replace(/<[^>]+>/g, '');
    },
    handleSizeChange(val) {
      this.nowPsz = val;
      this.listArticlesFuc();
    },
    handleCurrentChange(val) {
      this.nowPge = val;
      this.listArticlesFuc();
    },
    goToProjectDetail(item) {
      // 可替换为Vue Router跳转
      console.log('Go to project detail page');
      jumpTo(this, '案例详情', { id: item.id || '' }, {});
      // this.$router.push('/turnkey-projects/detail');
    },
    initTime(str) {
      return initTime(str, 'YYYY-MM-DD');
    },
    async listArticlesFuc() {

      const loading = this.$loading({
        lock: true,
        text: 'Loading...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });

      const res = await listArticles2({
        key: '',
        pge: this.nowPge,
        psz: this.nowPsz,
        type: this.nowType
      });

      loading.close();

      if (res.code === 200) {
        this.projectList = res.data || [];
        this.topList = res.itop || [];
        this.typeOptions = res.type || [];
        this.maxSize = res.count || 0;
        // 初始化项目推荐轮播Swiper
        this.$nextTick(() => {
          // 初始化Swiper轮播
          this.initSwiper();
          window.scrollTo(0, 0);
        });

      } else {
        this.$message.error(res.msg || 'Failed to load project list');
      }

    },
    // ========== 轮播初始化 ==========
    initSwiper() {
      this.$nextTick(() => {
        this.swiper = new Swiper('.swiper-al', {
          loop: true,
          speed: 1000,
          navigation: {
            nextEl: '.al_tj .swiper-button-next',
            prevEl: '.al_tj .swiper-button-prev',
          },
          pagination: {
            el: '.swiper-pagination',
            clickable: true,
          },
          slidesPerView: 1,
          spaceBetween: 10,
          autoplay: { // 可选：添加自动播放
            delay: 5000,
            disableOnInteraction: false
          }
        })
      })
    },

    // ========== 搜索功能 ==========
    toggleSearch() {
      this.searchVisible = !this.searchVisible
      if (this.searchVisible) {
        this.$nextTick(() => {
          const searchInput = document.querySelector('.sc_nr input')
          if (searchInput) searchInput.focus()
        })
      }
    },

    handleSearch() {
      if (!this.searchKeyword.trim()) {
        alert('Please enter search keywords')
        return
      }
      console.log('Search projects:', this.searchKeyword)
      this.searchVisible = false
    },

    // ========== 语言下拉框 ==========
    toggleLanguage() {
      this.languageDropdownVisible = !this.languageDropdownVisible
    },

    // ========== 移动端导航 ==========
    toggleMobileNav() {
      this.mobileNavVisible = !this.mobileNavVisible
      document.body.style.overflow = this.mobileNavVisible ? 'hidden' : ''
    },

    // ========== 分类筛选 ==========
    toggleDropdown() {
      this.dropdownOpen = !this.dropdownOpen;
    },
    onDocumentClick(e) {
      const el = this.$el?.querySelector('.al_lm-dropdown');
      if (el && !el.contains(e.target)) {
        this.dropdownOpen = false;
      }
    },
    selectCategory(item) {
      this.dropdownOpen = false;
      this.nowType = item.id;
      this.nowPge = 1;
      this.listArticlesFuc();
    },
    changeCategory(category) {
      this.activeCategory = category;
      // 重置分页
      this.currentPage = 1;

      this.nowType = category.id;

      this.listArticlesFuc();
      // 此处可添加分类筛选接口请求逻辑
      console.log('Change category to:', category);
    },

    // ========== 分页功能 ==========
    changePage(page) {
      if (page < 1 || page > this.totalPages) return
      this.currentPage = page
      // 滚动到项目列表顶部
      this.$nextTick(() => {
        const projectList = document.querySelector('.al_fl')
        if (projectList) {
          projectList.scrollIntoView({ behavior: 'smooth' })
        }
      })
      // 这里可添加加载对应页数据的逻辑
      console.log('Current page:', page)
    },

    // ========== 滚动相关 ==========
    handleScroll() {
      // 可添加滚动时的样式变化逻辑
    },

    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    }
  }
}
</script>
